import React, { useState } from 'react';
import { apiFetch } from './utils/api';

export default function MarketingPublishingSettings() {
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState({ url: '', username: '', category_id: '', app_password: '' });
  const [message, setMessage] = useState('');
  const [busy, setBusy] = useState(false);
  async function load() {
    setOpen(!open);
    if (open) return;
    setBusy(true);
    try { const response = await apiFetch('/api/marketing/publishing-settings'); setSettings({ ...await response.json(), app_password: '' }); }
    catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  }
  async function save(event) {
    event.preventDefault(); setBusy(true); setMessage('');
    try { await apiFetch('/api/marketing/publishing-settings', { method: 'PUT', body: JSON.stringify(settings) }); setSettings({ ...settings, app_password: '', password_configured: true }); setMessage('Publishing settings saved for your company.'); }
    catch (error) { setMessage(error.message); }
    finally { setBusy(false); }
  }
  return <section className="mb-5 rounded-lg border bg-white p-4">
    <button type="button" onClick={load} aria-expanded={open} className="font-semibold text-blue-800">WordPress connection</button>
    {open && <form onSubmit={save} className="mt-4 space-y-3">
      <p className="text-sm text-gray-600">Connect your company’s website to publish approved posts.</p>
      {[["url", "Website address", "url"], ["username", "WordPress username", "text"], ["app_password", "Application password", "password"], ["category_id", "Category ID (optional)", "text"]].map(([key,label,type]) =>
        <label key={key} className="block text-sm">{label}<input type={type} value={settings[key] || ''} onChange={event => setSettings({ ...settings, [key]: event.target.value })} className="mt-1 block w-full rounded border p-2" autoComplete="off" placeholder={key === 'app_password' && settings.password_configured ? 'Leave blank to keep saved password' : ''} /></label>)}
      <button disabled={busy} className="rounded bg-blue-700 px-4 py-2 text-white disabled:opacity-50">{busy ? 'Working…' : 'Save connection'}</button>
      {message && <p role="status" className="text-sm">{message}</p>}
    </form>}
  </section>;
}
